import React from 'react';
import styled from 'styled-components';
import { _ } from 'rc-locales';

const Container = styled.div`
  padding: 25px 15px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 18px;
`;

const Title = styled.h1`
  all: initial;
  display: block;
  color: #404040 !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  margin-bottom: 10px;
`;

const Sub = styled.p`
  color: #888;
  font-size: 13px !important;
`;

const Header = ({ children, kind }) => {
  const page = { 'event-list': _('deliver.events'), 'depo-list': _('deliver.depos') };
  return (
    <Container kind={kind}>
      <Title>{children}</Title>
      <Sub>{page[kind]}</Sub>
    </Container>
  );
};

export default Header;
